const escapeFileName = (filename: string): string =>
  filename.replace(/[/\\?%*:|"<>]/g, "")

export default escapeFileName
